import React,{useState,useEffect} from 'react'
import QRCode from 'qrcode';

function ProdQRCode(props) {
  const [image, setImage] = useState();

    useEffect(() => {
        generateQRCode(props.id)
    }, []);

    const generateQRCode = async (id)=>{
        try{
            const resp = await QRCode.toDataURL(id)
            setImage(resp)
        }catch(err){
            console.log(err)
        }
    }

  return (
    <div className='border-info border mb-2'>
        <img src={image} alt="qrcode" width="200px" className="align-self-center" />
        <br></br>
        <label>{props.name}</label>
    </div>
  )
}

export default ProdQRCode